/**
 * Copyright (c) 2022 Animation Studio Voronezh.
 *
 * CONFIDENTIAL AND PROPRIETARY
 *
 * This work is provided "AS IS" and subject to the Prodtrack
 * Source Code License. By accessing, using, copying or modifying
 * this work you indicate your agreement to the Prodtrack Source Code License.
 * All rights not expressly granted therein are reserved by Animation Studio Voronezh.
 */

export const tablePalette = {
    default: {
        light: {
            headerGray: "#F5F5F5",
            groupingGray: "#D9D9D9",
            rowGray: "#fff",
            selectedRow: "#dbecfa",
            selectedGroupingRow: "#dbdefa",

            ganttWeekend: "#b4b4b440",
            ganttToday: "#f04134",

            ganttTaskLink: "#000000de",
            ganttTask: {
                primary: "#65c16f",
                secondary: "#46ad51",
            },
            ganttTaskGroup: {
                primary: "#3db9d3",
                secondary: " #299cb4",
            },
            ganttMilestone: "#d33daf",

            ganttWarning: "#faad14",
            ganttDanger: "#f5222d",
        },
        dark: {
            headerGray: "#2e2f30",
            groupingGray: "#363636",
            rowGray: "#3b3b3b",
            selectedRow: "#526472",
            selectedGroupingRow: "#525972",

            ganttWeekend: "#b4b4b440",
            ganttToday: "#f04134",

            ganttTaskLink: "#dfdfdf",
            ganttTask: {
                primary: "#65c16f",
                secondary: "#46ad51",
            },
            ganttTaskGroup: {
                primary: "#3db9d3",
                secondary: " #299cb4",
            },
            ganttMilestone: "#d33daf",

            ganttWarning: "#faad14",
            ganttDanger: "#f5222d",
        },
    },
};
